<form #form="ngForm"
      method="post">
    <div class="flex flex-bottom flex-middle-s flex-middle-m">
        <input-wrap class="w-12">
            <div class="flex m-b-6-s m-b-6-m">

                <!-- input -->
                <input class="input m-r-2 b-t-0 b-l-0 b-r-0"
                       [ngClass]="{'error': status.error && !isValid}"
                       type="email"
                       name="email"
                       autocomplete="email"
                       (keyup)="validate()"
                       [(ngModel)]="data.email"
                       [muiInput]="('Please enter email address'| translate)"
                       (keyup.enter)="submit()"
                       cy-subscribeMailInput>

            </div>
        </input-wrap>
        <action class="button"
                [status]="status"
                sl-button="subscribe"
                cy-subscribeButton
                (click)="submit()">
            <span class="no-wrap"
                  translate>Sign up</span>
        </action>

    </div>

    <result class="block col-2 c1"
            sl-result="subscribe"
            cy-subscribeStatusMessage
            [status]="status"
            [success]="successMessage">
    </result>
</form>